import cx from 'classnames';
import PropTypes from 'prop-types';

import { LINK_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { LINK_TAG_NAME } from './constants';
import styles from './Link.css';

const Link = ({ className, LINK_TAG = LINK_TAG_NAME, ...attributes }) => {
  const RenderLeaf = ({
    children,
    element: { type, data },
    attributes: elementAttributes,
  }) => {
    if (type === LINK_DEFINITIONS.type) {
      return (
        <LINK_TAG
          {...attributes}
          {...elementAttributes}
          className={cx(styles.link, className)}
          data-editor-plugin={LINK_DEFINITIONS.type}
          href={data.href}
          target={data.target}
        >
          {children}
        </LINK_TAG>
      );
    }
  };
  return RenderLeaf;
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  className: PropTypes.string,
};

export { Link };
